import React from 'react';
import { Link } from 'react-router-dom';

const clients = [
  {
    id: 1,
    name: 'Indian Oil Corporation Ltd.',
    sector: 'Oil & Energy',
    logo: '/clients/indian-oil.png',
  },
  { id: 2, name: 'GAIL India Ltd.', sector: 'Oil & Gas', logo: '/clients/gail.png' },
  { id: 3, name: 'Alstom', sector: 'Rail & Manufacturing', logo: '/clients/alstom.png' },
  { id: 4, name: 'Jubilant FoodWorks', sector: 'Food & Retail', logo: '/clients/jubilant-foodworks.png' },
  { id: 5, name: 'VVIP Group', sector: 'Real Estate', logo: '/clients/vvip-group.png' },
  { id: 6, name: 'Supertech Limited', sector: 'Real Estate', logo: '/clients/supertech.png' },
  { id: 7, name: 'Nyati Engineers & Consultants', sector: 'Engineering', logo: '/clients/nyati.png' },
  { id: 8, name: 'Star Realcon', sector: 'Real Estate', logo: '/clients/star-realcon.png' },
  { id: 9, name: 'G&G Infrastructure', sector: 'Infrastructure', logo: '/clients/gg-infrastructure.png' },
  { id: 10, name: 'Gaurs Group', sector: 'Real Estate', logo: '/clients/gaurs-group.png' },
  { id: 11, name: 'Himalaya Real Estate Pvt Ltd', sector: 'Real Estate', logo: '/clients/himalaya-real-estate.png' },
  { id: 12, name: 'Aastha Channel', sector: 'Media', logo: '/clients/aastha-channel.png' },
  { id: 13, name: 'Kent RO', sector: 'Consumer Products', logo: '/clients/kent-ro.png' },
  { id: 14, name: 'Vishwanath Trading Company', sector: 'Trading · Lucknow', logo: '/clients/vishwanath-trading.png' },
  { id: 15, name: 'Barco Electronics India Pvt Ltd', sector: 'Electronics', logo: '/clients/barco.png' },
  { id: 16, name: 'Magnus Opto Systems India Pvt Ltd', sector: 'Opto Systems', logo: '/clients/magnus-opto.png' },
];

function OurClients() {
  return (
    <div className="page">
      <header className="page-header">
        <span className="page-eyebrow">Trusted By Industry Leaders</span>
        <h1 className="page-title">Our Esteemed Customers</h1>
        <p className="page-subtitle">
          We are proud to deliver prefab solutions for leading organizations across energy,
          real estate, manufacturing, and commercial sectors.
        </p>
      </header>

      <div className="clients-grid">
        {clients.map((client) => (
          <div key={client.id} className="client-card">
            <div
              className={`client-logo client-logo--image${client.darkLogo ? ' client-logo--dark' : ''}`}
            >
              <img src={client.logo} alt={`${client.name} logo`} />
            </div>
            <div>
              <h3>{client.name}</h3>
              <p className="client-sector">{client.sector}</p>
            </div>
          </div>
        ))}
      </div>

      <section className="cta-band" style={{ marginTop: '3rem' }}>
        <h2>Join Our Growing Client Network</h2>
        <p>Let us build the portable and prefab solution your business needs.</p>
        <Link to="/contact" className="btn btn-primary">
          Start a Conversation
        </Link>
      </section>
    </div>
  );
}

export default OurClients;
